export default "__VITE_ASSET__ec4db5c0__"